export default __webpack_public_path__ + "static/media/project_5_pic.cec25364.png";